import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SettingsProvider } from "./hooks/useSettings";
import { GameStatsProvider } from "./hooks/useGameStats";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SettingsProvider>
        <GameStatsProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </GameStatsProvider>
      </SettingsProvider>
    </I18nextProvider>
  );
}

export default App;
